/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Push_Event_Reminder_TitleInputs */

const th_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} กำลังจะเริ่ม`)
};

const en_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} starts soon`)
};

const ja_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} がまもなく開始`)
};

const zh_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即将开始`)
};

const es_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} empieza pronto`)
};

const pt_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} começa em breve`)
};

const id_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} segera dimulai`)
};

const fr_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} commence bientôt`)
};

const tl_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Malapit nang magsimula ang ${i?.event}`)
};

const vi_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} sắp bắt đầu`)
};

const ko_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}이(가) 곧 시작합니다`)
};

const de_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} beginnt bald`)
};

const ru_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} скоро начнётся`)
};

const tr_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} yakında başlıyor`)
};

const it_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} sta per iniziare`)
};

const pl_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} wkrótce się zaczyna`)
};

const uk_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} скоро починається`)
};

const hi_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} जल्द शुरू हो रहा है`)
};

const ar_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} على وشك البدء`)
};

const ms_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} akan bermula tidak lama lagi`)
};

const bn_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} শীঘ্রই শুরু হচ্ছে`)
};

const zh_tw2_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即將開始`)
};

const zh_hk2_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即將開始`)
};

const ur_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} جلد شروع ہو رہا ہے`)
};

const fa_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} به‌زودی آغاز می‌شود`)
};

const sw_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} unakaribia kuanza`)
};

const nl_push_event_reminder_title = /** @type {(inputs: Push_Event_Reminder_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} begint binnenkort`)
};

/**
* | output |
* | --- |
* | "{event} starts soon" |
*
* @param {Push_Event_Reminder_TitleInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_event_reminder_title = /** @type {((inputs: Push_Event_Reminder_TitleInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Event_Reminder_TitleInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_event_reminder_title(inputs)
	if (locale === "ja") return ja_push_event_reminder_title(inputs)
	if (locale === "zh") return zh_push_event_reminder_title(inputs)
	if (locale === "es") return es_push_event_reminder_title(inputs)
	if (locale === "pt") return pt_push_event_reminder_title(inputs)
	if (locale === "id") return id_push_event_reminder_title(inputs)
	if (locale === "fr") return fr_push_event_reminder_title(inputs)
	if (locale === "tl") return tl_push_event_reminder_title(inputs)
	if (locale === "vi") return vi_push_event_reminder_title(inputs)
	if (locale === "ko") return ko_push_event_reminder_title(inputs)
	if (locale === "de") return de_push_event_reminder_title(inputs)
	if (locale === "ru") return ru_push_event_reminder_title(inputs)
	if (locale === "tr") return tr_push_event_reminder_title(inputs)
	if (locale === "it") return it_push_event_reminder_title(inputs)
	if (locale === "pl") return pl_push_event_reminder_title(inputs)
	if (locale === "uk") return uk_push_event_reminder_title(inputs)
	if (locale === "hi") return hi_push_event_reminder_title(inputs)
	if (locale === "ar") return ar_push_event_reminder_title(inputs)
	if (locale === "ms") return ms_push_event_reminder_title(inputs)
	if (locale === "bn") return bn_push_event_reminder_title(inputs)
	if (locale === "zh-TW") return zh_tw2_push_event_reminder_title(inputs)
	if (locale === "zh-HK") return zh_hk2_push_event_reminder_title(inputs)
	if (locale === "ur") return ur_push_event_reminder_title(inputs)
	if (locale === "fa") return fa_push_event_reminder_title(inputs)
	if (locale === "sw") return sw_push_event_reminder_title(inputs)
	if (locale === "nl") return nl_push_event_reminder_title(inputs)
	return en_push_event_reminder_title(inputs)
});